<div ngbDropdown [class]="actionClass">
  <a class="nav-link dropdown-toggle no-caret p-2" [matBadge]="badgeCount" [matBadgeHidden]="!showBadge" matBadgeColor="primary" ngbDropdownToggle>
    <i [class]="'now-ui-icons ' + icon"></i>
  </a>
  <div ngbDropdownMenu class="dropdown-menu-right">
    @for (action of actions; track action) {
      @if (!isHidden(action)) {
        <a [routerLink]="" [class]="'dropdown-item' + classResolver(action)"
          (click)="clickHandler($event, action)" [class.disabled]="isDisabled(action)">
          <span>{{ action.text | translate }}</span>@if (hasIcon(action)) {
          <i [class]="'now-ui-icons ' + iconResolver(action)"></i>
        }
      </a>
    }
  }
</div>
</div>